// Centralized API base URL — decidido pela HOSTNAME em runtime (a prova de bala).
//
// PRODUCAO (qualquer host que nao seja localhost): same-origin ("" -> /api).
//   O nginx faz proxy de /api/ pro backend. Elimina CORS, Adblock cross-origin,
//   VPN bloqueando subdominio, e o bug de o build pegar localhost do .env de dev.
// DEV LOCAL (localhost/127.0.0.1): usa REACT_APP_BACKEND_URL ou localhost:8000.
const _ENV_URL = process.env.REACT_APP_BACKEND_URL;
const _isLocalhost = typeof window !== 'undefined'
  && /^(localhost|127\.0\.0\.1|0\.0\.0\.0)$/.test(window.location.hostname);

export const API_BASE = _isLocalhost ? (_ENV_URL || 'http://localhost:8000') : '';
export const API = `${API_BASE}/api`;
